<template>
  <div class="footer">
    <div class="footer-container">
      <div class="top">
        <div class="top-l">
          <a href="/about"><span v-if="language === 'ch'">关于我们</span><span v-else>About U</span> </a>
          <a href="/service"><span v-if="language === 'ch'">客户服务</span><span v-else>Customer Service </span></a>
          <a href="/disclaimer"><span v-if="language === 'ch'">免责声明</span><span v-else>Disclaimer</span></a>
          <a href="/privacy"><span v-if="language === 'ch'">隐私权政策</span><span v-else> Privacy Policy</span></a>
        </div>
        <div class="beian">粤ICP备06050840号</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      language: ''
    }
  },
  methods: {},
  created() { },
  mounted() {
    this.language = localStorage.getItem('curlanguage')
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
  font-size: 14px;
}
a {
  text-decoration: none;
}
/* 底部 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background: #282828;
  padding-left: 25px;
}

.footer-container > .top {
  width: 100%;
  height: 80px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.top-l a {
  text-decoration: none;
  color: #666666;
  margin-right: 24px;
}
.beian {
  color: #666666;
  margin-right: 65px;
}
</style>